export default {
  "luckywheelRecord.thead.userNo": "UserNo",
  "luckywheelRecord.thead.email": "Email",
  "luckywheelRecord.thead.rewardType": "Reward Type",
  "luckywheelRecord.thead.rewardName": "Reward Name",
  "luckywheelRecord.thead.firstName": "Firs tName",
  "luckywheelRecord.thead.lastName": "Last Name",
  "luckywheelRecord.thead.rewardAmount": "Reward Amount",
  "luckywheelRecord.thead.status": "Status",
  "luckywheelRecord.thead.createTime": "Create Time",
  "luckywheelRecord.thead.resultTime": "Result Time",
  "luckywheelRecord.title": "Lucky Wheel Record",
};
